import { useQuery, useMutation } from "react-query";
import {
  getPropertyContact,
  getAllPropertyContacts,
  getPropertyContactByProperty,
  createPropertyContact,
  updatePropertyContact,
  getAllPropertyContactsWithProperty,
  getPropertyContactByUserName,
} from "../../api/Onboarding/onboarding-property-contacts";

// Self service - get all property contacts
const useGetAllPropertyContacts = (options = {}) => {
  const records = useQuery(
    "getAllPropertyContacts",
    getAllPropertyContacts,
    options,
  );
  return records;
};

const useGetPropertyContactByUserName = (username, options = {}) => {
  const records = useQuery(
    ["getPropertyContactByUserName", username],
    () => getPropertyContactByUserName(username),
    options,
  );
  return records;
};

//get property contact
const useGetPropertyContact = (propertyContact, options = {}) => {
  const records = useQuery(
    ["getPropertyContact", propertyContact],
    () => getPropertyContact(propertyContact),
    options,
  );
  return records;
};

// Self service - get property contacts by customer
const useGetPropertyContactByProperty = (customerId, options = {}) => {
  const records = useQuery(
    ["getPropertyContactByProperty", customerId],
    () => getPropertyContactByProperty(customerId),
    options,
  );
  return records;
};

// Self service - create single property contact
const useCreatePropertyContact = (options = {}) => {
  return useMutation(createPropertyContact, options);
};

const useUpdatePropertyContact = (options = {}) => {
  return useMutation(updatePropertyContact, options);
};

const useGetAllPropertyContactsWithProperty = (options = {}) => {
  const records = useQuery(
    "getAllPropertyContactsWithProperty",
    getAllPropertyContactsWithProperty,
    options,
  );
  return records;
};

export {
  useGetPropertyContact,
  useGetAllPropertyContacts,
  useGetPropertyContactByProperty,
  useCreatePropertyContact,
  useUpdatePropertyContact,
  useGetAllPropertyContactsWithProperty,
  useGetPropertyContactByUserName,
};
